import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCustomCSS } from '../redux/configuration/selectors';

const CUSTOM_CSS_STYLE_ID = 'ods-custom-css';

export const useCustomCSS = (): void => {
    const customCSS = useSelector(getCustomCSS);

    useEffect(() => {
        // Remove existing custom style if any
        const existingStyle = document.getElementById(CUSTOM_CSS_STYLE_ID);
        if (existingStyle) {
            existingStyle.remove();
        }

        // Add new custom CSS if provided
        if (customCSS) {
            const styleElement = document.createElement('style');
            styleElement.id = CUSTOM_CSS_STYLE_ID;
            styleElement.textContent = customCSS;
            document.head.appendChild(styleElement);
        }

        // Cleanup on unmount
        return () => {
            const style = document.getElementById(CUSTOM_CSS_STYLE_ID);
            if (style) {
                style.remove();
            }
        };
    }, [customCSS]);
};
